import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  @font-face {
        font-family: "AvertaStdPE";
        src: url("../webfonts/346526_2_0.eot");
        src: url("../webfonts/346526_2_0.eot?#iefix") format("embedded-opentype"),
          url("../webfonts/346526_2_0.woff2") format("woff2"),
          url("../webfonts/346526_2_0.woff") format("woff"),
          url("../webfonts/346526_2_0.ttf") format("truetype");
        font-style: normal;
        font-weight: bold;
      }


      @font-face {
        font-family: "AvertaStdPE";
        src: url("../webfonts/346526_A_0.eot");
        src: url("../webfonts/346526_A_0.eot?#iefix") format("embedded-opentype"),
          url("../webfonts/346526_A_0.woff2") format("woff2"),
          url("../webfonts/346526_A_0.woff") format("woff"),
          url("../webfonts/346526_A_0.ttf") format("truetype");
        font-style: normal;
        font-weight: normal;
      }
      
  body {
  font-family: AvertaStdPE, serif ;
        font-style: normal;
    a {
      text-decoration: none;
    }
  }
  * {
    border: 0;
    margin: 0;
    outline: 0;
    padding: 0;
    font-size: 100%;
    font-style: inherit;
    font-family: inherit;
    font-weight: inherit;
    box-sizing: border-box;
    vertical-align: baseline;
  }
`;
export default GlobalStyle;
